import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Nav, Button } from 'react-bootstrap';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../../store/authActions';
import { fetchSectors, fetchAllCategories } from '../../store/actions';
import logo from '../../images/logo.png';
import './AdminLayout.css';

const AdminLayout = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    
    useEffect(() => {
        // Загружаем данные для админ-панели
        dispatch(fetchSectors());
        dispatch(fetchAllCategories());
    }, [dispatch]);

    const handleLogout = () => {
        dispatch(logout());
    };
    
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };
    
    return (
        <Container fluid className="p-0 admin-layout">
            {/* Мобильная кнопка для отображения сайдбара */}
            <div className={`mobile-menu-toggle d-md-none ${sidebarOpen ? 'd-none' : ''}`}>
                <Button 
                    variant="primary" 
                    onClick={toggleSidebar}
                    className="menu-toggle-btn"
                    aria-label="Открыть меню"
                >
                    ☰
                </Button>
            </div>
            
            {/* Мобильное меню - отдельный компонент */}
            <div className={`mobile-sidebar d-md-none ${sidebarOpen ? 'show' : ''}`}>
                <div className="mobile-sidebar-header">
                    <div className="d-flex align-items-center justify-content-center w-100">
                        {/* <span className="logo-text">ПерформанС</span> */}
                        <img 
                            src={logo} 
                            height="48" 
                            className="d-inline-block align-top" 
                            alt="Перформанс лого" 
                        />
                    </div>
                    <button 
                        className="close-sidebar" 
                        onClick={toggleSidebar}
                        aria-label="Закрыть меню"
                    >
                        ✕
                    </button>
                </div>
                
                <Nav className="flex-column mobile-nav">
                    <Nav.Link 
                        as={Link} 
                        to="/performance-admin-panel/products" 
                        className={`mobile-link ${location.pathname.includes('/products') ? 'active' : ''}`}
                        onClick={() => setSidebarOpen(false)}
                    >
                        Продукция
                    </Nav.Link>
                    <Nav.Link 
                        as={Link} 
                        to="/performance-admin-panel/categories" 
                        className={`mobile-link ${location.pathname.includes('/categories') ? 'active' : ''}`}
                        onClick={() => setSidebarOpen(false)}
                    >
                        Категории продукции
                    </Nav.Link>
                    <Nav.Link 
                        as={Link} 
                        to="/performance-admin-panel/project-categories" 
                        className={`mobile-link ${location.pathname.includes('/project-categories') ? 'active' : ''}`}
                        onClick={() => setSidebarOpen(false)}
                    >
                        Проекты
                    </Nav.Link>
                </Nav>
                
                <div className="mobile-logout">
                    <button 
                        className="btn btn-danger w-100" 
                        onClick={handleLogout}
                    >
                        Выход
                    </button>
                </div>
            </div>
            
            {/* Затемнение фона при открытом мобильном меню */}
            <div 
                className={`mobile-overlay d-md-none ${sidebarOpen ? 'show' : ''}`} 
                onClick={toggleSidebar}
            ></div>
            
            <Row className="m-0">
                {/* Десктопная левая боковая панель */}
                <Col md={2} className="p-0 sidebar d-none d-md-flex min-vh-100">
                    {/* Логотип или название компании */}
                    <div className="sidebar-header d-flex align-items-center justify-content-center p-3">
                        <Link to="/performance-admin-panel" className="text-decoration-none">
                            <div className="d-flex align-items-center">
                                {/* <span className="logo-text">ПерформанС</span> */}
                                <img 
                                    src={logo} 
                                    height="48" 
                                    className="d-inline-block align-top" 
                                    alt="Перформанс лого" 
                                />
                            </div>
                        </Link>
                    </div>

                    {/* Основное навигационное меню */}
                    <Nav className="flex-column mt-3">
                        <Nav.Link 
                            as={Link} 
                            to="/performance-admin-panel/products" 
                            className={`sidebar-link py-2 px-3 ${location.pathname.includes('/products') ? 'active' : ''}`}
                        >
                            Продукция
                        </Nav.Link>
                        <Nav.Link 
                            as={Link} 
                            to="/performance-admin-panel/categories" 
                            className={`sidebar-link py-2 px-3 ${location.pathname.includes('/categories') ? 'active' : ''}`}
                        >
                            Категории продукции
                        </Nav.Link>
                        <Nav.Link 
                            as={Link} 
                            to="/performance-admin-panel/project-categories" 
                            className={`sidebar-link py-2 px-3 ${location.pathname.includes('/project-categories') ? 'active' : ''}`}
                        >
                            Проекты
                        </Nav.Link>
                    </Nav>

                    {/* Кнопка выхода внизу сайдбара */}
                    <div className="logout-container">
                        <button 
                            className="btn btn-danger w-100" 
                            onClick={handleLogout}
                        >
                            Выход
                        </button>
                    </div>
                </Col>

                {/* Основной контент */}
                <Col xs={12} md={10} className={`p-0 content-area ${sidebarOpen ? 'blur' : ''}`}>
                    <div className="mobile-header d-md-none">
                        <h1 className="mobile-page-title">
                            Админ-панель
                            {/* {location.pathname.includes('/categories') ? 'Категории товаров' : 
                             location.pathname.includes('/project-categories') ? 'Категории проектов' : 
                             'Админ-панель'} */}
                        </h1>
                    </div>
                    {/* Основной контент страницы */}
                    <div className="px-0 px-md-4 py-4 mobile-content">
                        <Outlet />
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default AdminLayout;